<template>
  <AdmPanel>
    <h2 slot="header_title">历史得分</h2>
    <div class="filter-wrapper" v-loading="loader[SCORERANK+'fetch']">
      <FilterBar :value="conditions" :condition="options.filter_rules" :builder="builder" @search="changeQuery">
        <iv-form-item>
          <span class="adm-buttons">
            <iv-button :disabled="loader[SCORERANK+'fetch']" type="info"
              @click="changeQuery(mergeQuery({ ...conditions }))">
              <iv-icon type="ios-search" size="14" style="vertical-align:text-bottom" /> 查询 </iv-button>
          </span>
        </iv-form-item>
      </FilterBar>
    </div>
    <iv-table class="adm-table" :columns="columns" :loading="loader[SCORERANK+'fetch']" :data="list.data"
      @on-sort-change="SortList" @on-selection-change="onTableSelected">
    </iv-table>
    <template v-if="list.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total
          :total="list.total">
        </iv-page>
      </div>
    </template>
  </AdmPanel>
</template>
<script>
  import {
    RELEASE_TASKS,
    RELEASE_ADD_POLLING_TASK
  } from "@/stores/modules/release"
  import {
    mapActions,
    mapGetters
  } from 'vuex';

  import ModelMixin from "@/mixins/Model.mixin";
  import StatusMixin from "@/mixins/Status.mixin";
  import LoaderMixin from "@/mixins/Loader.mixin";

  import contact from "@/utils/contact";
  import {
    conditioner,
    defaultVal,
    unique,
    downloadByUrl,
  } from '@/utils/';

  import CheckedList from "@/components/CheckedList";
  import CompanySelect from "@/components/CompanySelect"
  import CarbonScorerankModel from '@/models/CarbonScorerankModel';
  import CarbonIndustryModel from "@/models/CarbonIndustryModel";
  import CarbonCompanyModel from '@/models/CarbonCompanyModel'
  import ReleaseModel from '@/models/ReleaseModel'

  import fecha from "fecha"
  const _years = [
    { id: 2023, name: '2023', title: '2023'},
    { id: 2022, name: '2022', title: '2022'}
  ]
  const options = {}
  const filter_rules = [
      { name: "year", type: "Select", options: _years, title: "年份", default: "", placeholder: "年份", style: { width:
      "100px" } },
      { name: "industry", type: "Select", options: [], title: "行业", default: "", placeholder: "行业", clearable: true,
      style: { width:
      "150px" } },
      {
        name: 'stockCodeList',
        type: 'CompanySelect',
        options: [],
        title: '公司',
        default: [],
        placeholder: '公司',
        clearable: true,
        filterable: true,
        style: { width: '200px' },
      },
      // { name: 'stockCodeList', type: 'Select', options: [], title: '公司', default: '', placeholder: '公司', filterable: true,
      // clearable: true, style: { width: '150px' } },
  ]
  const _conditioner = conditioner(
    {//ui到url
      limit : {type: Number, default: 10},
      dataSource : {type: String , default: ''},
      year: { type: Number, default: null },
      industry: { type: String, default: null },
      stockCodeList: { type: val=> JSON.stringify(val), default: '' },
    },
    {//url到ui
      limit : {type: Number, default: 10},
      dataSource : {type: String , default: ''},
      year: { type: val => parseInt(val), default: () => _years[0].id },
      industry: { type: String, default: null },
      stockCodeList: { type: val=> val?JSON.parse(val):[], default: ''},
    }
  )
  function columns(vm){
    return [
      {
          title: "排行",
          key: "rank",
          align: "center",
          minWidth: 120,
      },
      {
          title: "公司名称",
          key: "abbreviation",
          align: "center",
          minWidth: 120,
      },
      {
          title: "年份",
          key: "year",
          align: "center",
          minWidth: 120,
      },
      {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 120,
      },
      {
          title: "得分",
          key: "score",
          align: "center",
          minWidth: 120,
      },
    ]
  }


  const COMPANY = CarbonCompanyModel.ModelName;
  const SCORERANK = CarbonScorerankModel.ModelName
  const INDUSTRY = CarbonIndustryModel.ModelName
  const RELEASE = ReleaseModel.ModelName

  export default {
    name: "public_sentiment",
    mixins: [
      LoaderMixin(COMPANY, SCORERANK, SCORERANK + 'fetch', SCORERANK + 'export', INDUSTRY, RELEASE),
      ModelMixin({
        contact,
        models: [
          CarbonCompanyModel,
          CarbonScorerankModel,
          CarbonIndustryModel,
          ReleaseModel
        ]
      })
    ],
    data() {
      return {
        columns: columns(this),
        conditions:{
          ... _conditioner.default(),
          companyInput: ''
        },
        SCORERANK,
        INDUSTRY,
        list: {
          data: [],
          last_page: 0,
          current_page: 1
        },
        options: {
          ...options,
          companys: [],
          industry: [],
          filter_rules,
          year: _years
        },
        secondTarget: '',
        sources: {
          loading: false,
          companyFake: ''
        },
        modal: {
          release: {
            shown: false,
            data: {
              year: "",
              rankDisplayTime: fecha.parse(fecha.format(new Date, "YYYY-MM-DD"), "YYYY-MM-DD 00:00:00"),
              subRankDisplayTime: fecha.parse(fecha.format(new Date, "YYYY-MM-DD"), "YYYY-MM-DD 00:00:00"),
            }
          }
        },
        selection: {
          list: [],
          comment: "",
          shown: false,
          shown2: false,
        },
        builder:{
            'renderCompanySelect': (vm,h,{ fieldset, values } = {})=>{ //必须加`render`前序
              return <CompanySelect
                { ...{
                style: fieldset.style,
                props: {
                  ...fieldset,
                  sourceType:"carbonCompany",
                  value: values[fieldset.name] || fieldset.default,
                },
                on: {
                  'change': $event=>vm.onValueChanged($event, fieldset.name), //调用FilterBar对象内部函数
                }
                }}
              ></CompanySelect>
            }
          }
      }
    },
    async mounted() {
      const {
        query,
        params
      } = this.$route
      let conditions = _conditioner.serialize({
        ...query,
        ...params
      }) //处理成支持UI的格式
      let parse_conditions = _conditioner.parse(conditions)
      this.conditions.year = defaultVal(this.conditions.year, this.options.year[0].id);
      const industries = await this.refreshIndustry()
      
      conditions.industry = conditions.industry ? conditions.industry : industries[0].id
      // const companys = await this.refreshCompanys()
      this.renderFilterBar('industry', industries)
      // this.renderFilterBar('stockCodeList', companys)
      conditions.statistics = conditions.statistics ? conditions.statistics : (this.isAudit ? '1' : '0')
      this.conditions = conditions

      const rule = this.options.filter_rules.find(i=>i.name=='stockCodeList')
      rule.input = this.conditions.companyInput

      this.$nextTick(() => {
        this.refresh(conditions)
      })
    },
    beforeRouteUpdate(to, from, next) {
      this.$nextTick(async () => {
        const {
          query,
          params
        } = to
        let conditions = {
          ..._conditioner.default(),
          ..._conditioner.serialize({
            ...query,
            ...params
          }) //处理成支持UI的格式
        }
        console.log(this.options.year,'this.options.year')
        conditions.year = defaultVal(this.conditions.year, this.options.year[0].id);
        let parse_conditions = _conditioner.parse(conditions)
        conditions.statistics = conditions.statistics ? conditions.statistics : (this.isAudit ? '1' : '0')
        this.conditions = conditions
        const rule = this.options.filter_rules.find(i=>i.name=='stockCodeList')
        rule.input = this.conditions.companyInput
        this.refresh()
      })
      next();
    },
    methods: {
      ...mapActions([RELEASE_ADD_POLLING_TASK]),
      async refresh(query = this.conditions) {
        this.$$loading(SCORERANK);
        this.list = await this.$$fetch(SCORERANK, _conditioner.parse({
          ...query,
          type: 'scoreHistoryRank'
        }));
        console.log(this.list,'this.list')
        this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset /
        _conditioner.parse(query).limit + 1 : 1
        this.list.last_page = this.list.total / _conditioner.parse(query).limit
        this.$$loaded(SCORERANK);
        // if (result instanceof Error) return
        // this.list.data = result.data
        // this.list.total = result.total
        // this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner
        //   .parse(query).limit + 1 : 1;
        // this.list.last_page = result.total / _conditioner.parse(query).limit;
        // this.columns = result.data.columns.map(column => ({
        //   align: "left",
        //   minWidth: 120,
        //   ...column,
        // }))
      },
      async refreshCompanys(industryId) {
        const company = await this.$$fetch(COMPANY)
        return (this.options.companys = company.data.map(item => ({
          id: item.stockCode,
          name: item.stockCode + ' ' + item.abbreviation
        })))
      },
      async refreshIndustry() {
        const industry = await this.$$active(SCORERANK, 'historyIndustry',{
          allTag: 1 //全部标记0-只返回正常公司:1-返回全部公司
        })
        if (industry) this.options.industry = industry.data.map(item => ({
          name: item,
          id: item
        }))
        return this.options.industry
      },
      renderFilterBar(fieldName, val, defaults) {
        const fieldset = this.options.filter_rules.find(fieldset => fieldset.name === fieldName)
        fieldset.options = val
      },
      pageChanged(page) {
        this.$router.push({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            offset: (page - 1) * _conditioner.parse(this.conditions).limit
          },
          params: this.$route.params
        });
      },
      mergeQuery(query) {
        return {
          ...this.conditions,
          ...query
        }
      },
      changeQuery(query = this.conditions, params = this.$route.params) {
        this.$router.push({
          name: this.$route.name,
          query: {
            ..._conditioner.parse(query)
          },
          params: params
        });
      },
      SortList(val) {
        this.conditions.ordering = val.order == "normal" ? "" : val.order == "desc" ? `-${val.key}` : val.key;
        this.changeQuery();
      },
      onTableSelected(selection) {
        this.selection.list = selection
      },
    },
    watch: {
      // 'conditions.year': {
      //   async handler(newVal, oldVal) {
      //     if (oldVal) {
      //       let industries = await this.refreshIndustry(newVal)
      //       this.renderFilterBar('industryId', industries)
      //     }
      //     const conditions = _conditioner.parse({
      //       year: newVal
      //     })
      //     this.modal.release.data.year = conditions.year
      //   }
      // },
      // 'conditions.industryId': {
      //   async handler(newVal, oldVal) {
      //     if (oldVal) {
      //       let companys = await this.refreshCompanys(newVal)
      //       this.renderFilterBar('stockCode', companys)
      //     }
      //   }
      // }
    },
    computed: {
      ...mapGetters([RELEASE_TASKS]),
      isAudit() {
        return this.$route.matched.some(item => item.name == 'audit')
      }
    },
    components: {
      CheckedList,
      CompanySelect
    }
  }
</script>
<style lang="scss" scoped>
  .checked-list {
    margin-top: -10px;
    display: flex;
    align-items: baseline;

    @media screen and (min-width: 768px) {
      display: flex;
    }

    &__title {
      flex-shrink: 0;
      margin-right: 5px;
      margin-bottom: 10px;
      display: block;

      @media screen and (min-width: 768px) {
        text-align: right;
      }
    }

    &__body {
      flex-grow: 1;

      >* {
        margin-bottom: 5px;
      }
    }
  }

  .filter-wrapper {
    position: relative;

    .export-excel-btn {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
</style>
